import { ref } from 'vue'
import { defineStore } from 'pinia'
import { fetchMenuApi } from '@/service'

export const useNavigationStore = defineStore('navigation', () => {
  const servicesShow = ref(false)
  const menuShow = ref(false)
  const searchShow = ref(false)
  const menu = ref([])

  const loaderPage = ref(false)

  const startLoaderPage = () => {
    loaderPage.value = true
  }

  const endLoaderPage = () => {
    loaderPage.value = false
  }

  const openServices = () => {
    servicesShow.value = !servicesShow.value
  }

  const openMenu = () => {
    menuShow.value = !menuShow.value
  }

  const openSearch = () => {
    menuShow.value = false
    searchShow.value = !searchShow.value
  }

  const fetchMenu = () => {
    return fetchMenuApi().then((response) => {
      menu.value = response
      return Promise.resolve()
    })
  }

  return {
    menu,
    servicesShow,
    menuShow,
    searchShow,
    loaderPage,
    startLoaderPage,
    endLoaderPage,
    openServices,
    openMenu,
    openSearch,
    fetchMenu
  }
})
